var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa fa-code",attrs:{"title":_vm.asJson}})
}
var staticRenderFns = []

export { render, staticRenderFns }